import { useEffect, useState, useRef } from "react";

import styles from "./Face3.module.scss";

export default function Face3() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [marginLeft, setMarginLeft] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.035 * cardRef.current.clientWidth));
        setLetterSpacing(0.002 * cardRef.current.clientWidth);
        setLineHeight(0.05 * cardRef.current.clientWidth);
        setMarginLeft(0.4 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
          marginLeft: `${marginLeft}px`,
          width: "100%",
        }}
      >
        <p>Luteal phase</p>
        <p>the Moon suffocating in Aquarius</p>
        <p>Hips sticking out</p>
        <p>the twill waistband blistering</p>
        <p>What I want is</p>
        <p>to smoke cigarettes</p>
        <p>on the warm concrete in front of Rojc.</p>
        <br></br>
        <p>But you're too young!</p>
        <p>and you're a moron</p>
        <br></br>
        <p>if you knew how old my soul is</p>
        <p>we wouldn't even talk</p>
        <p>so we don't talk</p>
        <p>about the lives inside me or how many there are</p>
        <br></br>
        <p>who tf even is Kamala!</p>
        <br></br>
        <p>Birds are not free from desire</p>
        <p>I am not living being alive</p>
        <p>pouring naked crumbs into puddles</p>
        <p>for a smile, morale, making happy.</p>
      </div>
    </div>
  );
}
